<template>
  <div id="top"
       v-if="initOk">
    <div style="background-color:#fff">
      <!-- 保經表單 -->
      <v-tabs
              color="cyan"
              dark
              icons-and-text
              hide-slider
              v-model="tabAecActive"
              class="tab-sec-style">
        <v-tab href="#tab-1"
               v-if="tabShow.tab1"
               :ripple=false>
          <v-icon v-if="isDoneTab1"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>確認客戶身分暨洗錢及資恐風險評估表</span>
        </v-tab>
        <!-- SCR #89564 ， 調整為 一律不顯示此頁籤 tab2 -->
        <!-- <v-tab href="#tab-2"
               v-if="tabShow.tab2"
               :ripple=false>
          <v-icon v-if="isDoneTab2"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span ref="tab2">高風險客戶之盡職調查</span>
        </v-tab> -->
          <!-- Issue #83806拿掉 -->
        <v-tab href="#tab-3"
               v-if='false'
               :ripple=false>
          <v-icon v-if="isDoneTab3"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>壽險新進件檢核表</span>
        </v-tab>
        <v-tabs-items touchless>
          <v-tab-item value="tab-1"
                      v-if='tabShow.tab1'
                      lazy>
            <risk-disclosure ref="tab1Compont"
                             :trans-code="transCode"
                             :pnop="pnop"
                             :prop-annex-risk="annexRisk"
                             :cus-o="cusO"
                             :ins-pol="insPol"
                             :ins-policies-data="insPoliciesData"
                             :country-list="countryList"
                             :srv12-list="srv12List"
                             :srv14-list="srv14List"
                             :is-done="isDoneTab1"
                             :pol-insure-type="polInsureType"
                             :pol-num="polNum"
                             @goTop="goTop"
                             @close="close"
                             @forceClose="forceClose"
                             @setTabDone="setTabDone"
                             @setTab2Show="setTab2Show"
                             @toNextTab="toNextTab"
                             ></risk-disclosure>
          </v-tab-item>
          <!-- SCR #89564 ， 調整為 一律不顯示此頁籤 tab2 -->
          <v-tab-item value="tab-2" v-if='false' lazy>
            <high-risk ref="tab2Compont"
                       :trans-code="transCode"
                       :prop-annex-edd="annexEdd"
                       :annex-code="tab2AnnexCode"
                       :annex-version="tab2AnnexVersion"
                       :cus-o="cusO"
                       @goTop="goTop"
                       @close="close"
                       @setTabDone="setTabDone"
                       @toNextTab="toNextTab"
                       ></high-risk>
          </v-tab-item>

          <!-- Issue #83806拿掉 -->
        <!--
          <v-tab-item value="tab-3"
                       v-if='tabShow.tab3'
                      lazy>
            <new-ins ref="tab3Compont"
                     :trans-code="transCode"
                     :new-ins-data="newInsData"
                     :annex-code="tab3AnnexCode"
                     :annex-version="tab3AnnexVersion"
                     :cus-o="cusO"
                     @goTop="goTop"
                     @close="close"
                     @setTabDone="setTabDone"
                     @toNextTab="toNextTab"
                     ></new-ins>
          </v-tab-item>
          -->
        </v-tabs-items>
      </v-tabs>
      <base-btn v-if="showDoneBtn">
        <btn-lg-primary @click="done"
                        ref="mainDoneBtn">檢查漏勾漏填</btn-lg-primary>
      </base-btn>
    </div>
    <base-btn v-if="!moneyLaundMode">
      <btn-lg-default @click="cleanAll"
                      class="float-left">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary @click="nextStepHandler"
                      :disabled="isDisabled">完成</btn-lg-primary>
    </base-btn>
    <template v-if="!moneyLaundMode">
      <btn-lg-primary :disabled="isDisabled"
                      style="position: fixed;top: 300px;right: 30px;min-width: 126px;"
                      @click="nextStepHandler">完成</btn-lg-primary>
      <btn-lg-primary ref="floatDoneBtn"
                      large
                      dark
                      color="primary"
                      style="position: fixed;top: 360px;right: 30px;min-width: 126px;max-width: 126px;"
                      @click="done">檢查漏勾漏填</btn-lg-primary>
    </template>
  </div>
</template>

<script>
import ProposalStepsBase from './ProposalStepsBase'
import RiskDisclosure from './AgentFiles/RiskDisclosure'
import HighRisk from './AgentFiles/HighRisk'
// import NewIns from './AgentFiles/NewIns'
import store from '@/store'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
const { mapActions: commonMapActions } = createNamespacedHelpers('ins')
export default {

  extends: ProposalStepsBase,
  components: {
    RiskDisclosure,
    HighRisk
  },

  mixins: [],

  props: {
    moneyLaundMode: Boolean,
    propTransCode: String
  },

  data () {
    return {
      initOk: false,
      tabAecActive: null,
      tab1AnnexCode: '',
      tab1AnnexVersion: '',
      tab2AnnexCode: '',
      tab2AnnexVersion: '',
      tab3AnnexCode: '',
      tab4AnnexVersion: '',
      isDoneTab1: false,
      isDoneTab2: false,
      isDoneTab3: false,
      showDoneBtn: true,
      tabShow: { tab1: false, tab2: false, tab3: false },
      pnop: '',
      annexRisk: {},
      annexEdd: {},
      newInsData: [],
      cusO: {},
      insPol: {},
      insPoliciesData: {},
      srv12List: [],
      srv14List: [],
      polNum: null,
      email: '',
      eddState: 'N',//fix: SCR #89564 , 加上『EDD狀態代碼』旗標
    }
  },

  mounted () {
    /*
    this.$nextTick(() => {
      document.getElementsByClassName('v-tabs__icon--next')[0] && document.getElementsByClassName('v-tabs__icon--next')[0].click()
    })
    */
  },

  computed: {
    isDisabled () {
      // let flag = !((!this.tabShow.tab1 || this.isDoneTab1) && (!this.tabShow.tab2 || this.isDoneTab2) && (!this.tabShow.tab3 || this.isDoneTab3))
      let flag = !((!this.tabShow.tab1 || this.isDoneTab1) && (!this.tabShow.tab2 || this.isDoneTab2))
      if (flag) {
        this.$emit('done-change', false)
      }
      return flag
    }
  },

  watch: {
    isDisabled (val) {
      if (this.moneyLaundMode) {
        this.$emit('set-money-laund-confirm-flag', !val)
      }

    },
    tabAecActive: {
      immediate: true,
      handler (newVal, oldVal) {
        let vm = this
        switch (newVal) {
          case 'tab-1':
            this.showDoneBtn = true
            this.$nextTick(() => {
              setTimeout(() => {
                vm.$refs.tab1Compont.doValidate()
              }, 0)
            })
            break
          case 'tab-2':
            this.showDoneBtn = true
            this.$nextTick(() => {
              setTimeout(() => {
                vm.$refs.tab2Compont.doValidate()
              }, 0)
            })
            break
          case 'tab-3':
            /* Issue #83806 拿掉
            this.showDoneBtn = true
            this.$nextTick(() => {
              setTimeout(() => {
                vm.$refs.tab3Compont.doValidate()
              }, 0)
            })
            */
            break
        }
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    const { transCode } = to.params.propKey
    const reqCusInfo = store.dispatch('ins/fetchCusInfo', { transCode, cusType: ['O'] })
    const f1 = store.dispatch('ins/fetchAgentFilesReq', { transCode })
    Promise.all([f1,reqCusInfo]).then(r => {
      const [ rF1,rCusInfo ] = r
      let f2 = () => {
        return store.dispatch('ins/fetchPolicyStatusNum', {
                transCode,
                cusIdn: rF1.data.cusO.cusIdn,
                polState: ['S']
              })
      }

      f2().then(rF2 => {
        next(vm =>{
          vm.transCode = transCode
          const cusOInfo=rCusInfo.data.cusList[0]
          vm.email = cusOInfo.email
          vm.setResData(rF1.data, rF2.data)
          vm.initTabsData()
          vm.initOk = true
        })
      })

    })

  },

  created () {
    if (this.moneyLaundMode) {
      let vm = this
      const transCode = this.propTransCode
      this.transCode = transCode
      const f1 = store.dispatch('ins/fetchAgentFilesReq', { transCode })
      Promise.all([f1]).then(r => {
        const [ rF1 ] = r
        let f2 = () => {
          return store.dispatch('ins/fetchPolicyStatusNum', {
                  transCode,
                  cusIdn: rF1.data.cusO.cusIdn,
                  polState: ['S']
                })
          }

        f2().then(rF2 => {
          vm.setResData(rF1.data, rF2.data)
          vm.initTabsData()
          vm.initOk = true
        })

      })
    }
  },

  methods: {
    ...commonMapActions([
      'agentFilesFinish'
    ]),
    toNextTab () {
      let vm = this
      this.$nextTick(() => {
        setTimeout(() => {
          if (vm.tabShow.tab1 && !vm.isDoneTab1) {
            vm.tabAecActive = 'tab-1'
          } else if (vm.tabShow.tab2 && !vm.isDoneTab2) {
            vm.tabAecActive = 'tab-2'
          }
          /* Issue #83806拿掉
           else if (vm.tabShow.tab3 && !vm.isDoneTab3) {
            vm.tabAecActive = 'tab-3'
          }
          */
        }, 0)

      })

    },
    setResData (v, v2) {
      if (v) {
        this.pnop = v.pnop
        this.insPol = v.insPol
        this.cusO = v.cusO
        this.annexRisk = v.insPoliciesAnnexRisk
        this.annexEdd = v.insPoliciesAnnexEdd
        this.newInsData = v.newInsData

        this.insPoliciesData = v.insPoliciesData
        this.srv12List = v.srv12List
        this.srv14List = v.srv14List

        this.tab1AnnexCode = v.tab1AnnexCode
        this.tab1AnnexVersion = v.tab1AnnexVersion
        this.tab2AnnexCode = v.tab2AnnexCode
        this.tab2AnnexVersion = v.tab2AnnexVersion
        this.tab3AnnexCode = v.tab3AnnexCode
        this.tab3AnnexVersion = v.tab3AnnexVersion
        this.isDoneTab1 = v.tab1Done
        // this.isDoneTab1 = false
        this.isDoneTab2 = v.tab2Done
        // this.isDoneTab2 = false
        //this.isDoneTab3 = v.tab3Done
      }
      if (v2) {
        this.polNum = v2.POL_NUM
      }
    },
    initTabsData () {
      this.tabAecActive = 'tab-1'

      this.tabShow.tab1 = true
      this.tabShow.tab2 = false

      if (this.moneyLaundMode) {
        this.isDoneTab1 = false
        this.isDoneTab2 = false
      }

    },
    externalDone () {
      switch (this.tabAecActive) {
        case 'tab-1':
          this.$refs.tab1Compont.done()
          return
        case 'tab-2':
          this.$refs.tab2Compont.done()
          return
        /* Issue #83806拿掉
        case 'tab-3':
          this.$refs.tab3Compont.done()
          return
          */
      }
    },
    done: withDebounce(function () {
      if (!this.moneyLaundMode) {
        this.$refs.floatDoneBtn.$data.loader = 'loading'
        this.$refs.mainDoneBtn.$data.loader = 'loading'
      }
      switch (this.tabAecActive) {
        case 'tab-1':
          this.$refs.tab1Compont.done()
          if (this.moneyLaundMode) {
            this.$postUserAccessLog({ progClassName: 'searchPageMoneyLaund_riskDisclosure_MissingCheck', methodName: '檢查漏勾填', stepCode: '', transCode: this.transCode })
          } else {
            this.$postUserAccessLog({ progClassName: 'riskDisclosure_missingCheck', methodName: '檢查漏勾填', stepCode: this.tabStep, transCode: this.transCode })
          }
          return
        case 'tab-2':
          this.$refs.tab2Compont.done()
          if (this.moneyLaundMode) {
            this.$postUserAccessLog({ progClassName: 'searchPageMoneyLaund_highRisk_MissingCheck', methodName: '檢查漏勾填', stepCode: '', transCode: this.transCode })
          } else {
            this.$postUserAccessLog({ progClassName: 'highRisk_missingCheck', methodName: '檢查漏勾填', stepCode: this.tabStep, transCode: this.transCode })
          }
          return
          /* Issue #83806拿掉
          case 'tab-3':
          this.$refs.tab3Compont.done()
          this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'newIns_missingCheck', methodName: '檢查漏勾填', transCode: this.transCode }))
          return
          */
      }
      this.$emit('go-top')// 觸發父層 goTop event
    }),
    goTop () {
      this.$emit('go-top')// 觸發父層 goTop event
    },
    close () {
      this.$emit('close')
    },
    forceClose () {
      this.$emit('forceClose')
    },
    setTabDone (flag) {
      switch (this.tabAecActive) {
        case 'tab-1':
          this.isDoneTab1 = flag
          break
        case 'tab-2':
          this.isDoneTab2 = flag
          break
        /* Issue #83806拿掉
        case 'tab-3':
          this.isDoneTab3 = flag
          break
        */
      }
      // this.$emit('go-top')// 觸發父層 goTop event
    },
    setTab2Show (flag) {
      if(flag){
        this.eddState = 'P' //『EDD狀態代碼』旗標 = 'P'
      }else{
        this.eddState = 'N'
      }
      //fix: SCR #89564 , 移除此功能
      //this.tabShow.tab2 = flag
      /*
      let vm = this
      if (flag) {
        this.$nextTick(() => {
          vm.$refs.tab2.click()
        })
      }
      */
    },
    setShowDone (flag) {
      switch (this.tabAecActive) {
        case 'tab-1':
          this.showDoneBtn = flag
          break
        case 'tab-2':
          this.showDoneBtn = flag
          break
        /* Issue #83806拿掉
        case 'tab-3':
          this.showDoneBtn = flag
          break
        */
      }
    },
    cleanAll () {
      switch (this.tabAecActive) {
        case 'tab-1':
          this.isDoneTab1 = false
          this.$refs.tab1Compont.cleanAll()
          this.$postUserAccessLog({ progClassName: 'agentFiles_clearTab1', methodName: '全部清除', stepCode: this.tabStep, transCode: this.transCode })
          break
          case 'tab-2':
            this.isDoneTab2 = false
            this.$refs.tab2Compont.cleanAll()
            this.$postUserAccessLog({ progClassName: 'agentFiles_clearTab3', methodName: '全部清除', stepCode: this.tabStep, transCode: this.transCode })
            break
            /* Issue #83806拿掉
            case 'tab-3':
              this.isDoneTab3 = false
              this.$refs.tab3Compont.cleanAll()
              this.$postUserAccessLog({ progClassName: 'agentFiles_clearTab3', methodName: '全部清除', stepCode: this.tabStep, transCode: this.transCode })
            break
            */
      }
      this.$emit('go-top')// 觸發父層 goTop event
    },
    tempSave: withDebounce(function () {
      switch (this.tabAecActive) {
        case 'tab-1':
          // this.isDoneTab1 = false // 改在 this.$refs.tab1Compont.tempSave() 內做，因為要判斷是否有異動
          this.$refs.tab1Compont.tempSave()
          if (this.moneyLaundMode) {
            this.$postUserAccessLog({ progClassName: 'searchPageMoneyLaund_tempTab1Save', methodName: '暫存', stepCode: '', transCode: this.transCode })
          } else {
            this.$postUserAccessLog({ progClassName: 'riskDisclosure_tempSaveTab1', methodName: '暫存', stepCode: this.tabStep, transCode: this.transCode })
          }
          break
          case 'tab-2':
            this.isDoneTab2 = false
            this.$refs.tab2Compont.tempSave()
            if (this.moneyLaundMode) {
              this.$postUserAccessLog({ progClassName: 'searchPageMoneyLaund_tempTab2Save', methodName: '暫存', stepCode: '', transCode: this.transCode })
            } else {
              this.$postUserAccessLog({ progClassName: 'highRisk_tempSaveTab2', methodName: '暫存', stepCode: this.tabStep, transCode: this.transCode })
            }
            break
            /* Issue #83806拿掉
            case 'tab-3':
              this.isDoneTab3 = false
              this.$refs.tab3Compont.tempSave()
              this.$postUserAccessLog({ progClassName: 'newIns_tempSaveTab3', methodName: '暫存', stepCode: this.tabStep, transCode: this.transCode })
             break
             */
      }
    }),
    preStepHandler: withDebounce(function () {
      this.$postUserAccessLog({ progClassName: 'agentFiles_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    }),
    nextStepHandler (callback) {
      if (this.moneyLaundMode && this.isDisabled) {
        this.$alert('請先完成 檢查漏勾漏填!')
        return
      }

      if(this.polInsureType ==='R') {
         if(!this.email) {
            this.$alert('因客戶未留信箱，請下載並列印書面分析報告後郵寄予客戶，並於系統填入寄送日期本案才能送交保經簽署人簽核後給予保險公司!')
         }
      }
      //fix: SCR #89564 , 調整 needEdd 判斷作法
      this.agentFilesFinish({
        transCode: this.transCode,
        //needEdd: (this.tabShow.tab2)?'Y': 'N',
        needEdd: (this.eddState === 'P')?'Y': 'N',
        moneyLaundMode: (this.moneyLaundMode)?'Y':'N'
      }).then(r => {
        if (r.data.error) {
          this.$alert(r.data.error)
          return
        }
        //fix: SCR #89564 , 移除 this.$alert(r.data.msg
        //this.$alert(r.data.msg, () => {
          if (this.moneyLaundMode) {
            this.$postUserAccessLog({ progClassName: 'searchPageMoneyLaund_audit', methodName: '送審', stepCode: '', transCode: this.transCode  })
          } else {
            this.$postUserAccessLog({ progClassName: 'agentFiles_confirm', methodName: '完成', stepCode: this.tabStep, transCode: this.transCode  })
          }

          if (r.data.emailErr1 || r.data.emailErr2 || r.data.emailErr3) {
            r.data.emailErr1 && this.$alert(r.data.emailErr1)
            r.data.emailErr2 && this.$alert(r.data.emailErr2)
            r.data.emailErr3 && this.$alert(r.data.emailErr3)
          } else if (r.data.msgCal) {
            this.$alert(r.data.msgCal, () => {
              if (this.moneyLaundMode) {
                callback && callback()
              } else {
                this.$router.replace({ name: 'proposal' })
              }
            })
          } else {
            if (this.moneyLaundMode) {
              callback && callback()
            } else {
              this.$router.replace({ name: 'proposal' })
            }

          }

        //})
      })
    },
  }

}
</script>
